import { useQuery } from '@tanstack/react-query';

import { useOpalUser } from '@frontend/hooks';

import { DEFAULT_GET_STALE_TIME } from '../constants';
import { ConnectionServices } from '../services';

const SELF_CONNECTIONS_QUERY_KEY = 'self-connections';

export function useSelfConnections() {
  const { opalUser } = useOpalUser();
  const query = useQuery({
    queryKey: [SELF_CONNECTIONS_QUERY_KEY],
    queryFn: async () => {
      return await ConnectionServices.getSelfConnections(opalUser.instance.instance_id);
    },
    staleTime: DEFAULT_GET_STALE_TIME * 5,
  });

  return { selfConnectionsQuery: query };
}
